import React from "react";

const sizeMap = {
  small: { box: "w-4 h-4", border: "border-2" },
  medium: { box: "w-8 h-8", border: "border-[3px]" },
  large: { box: "w-12 h-12", border: "border-[3px]" },
};

const LoadingSpinner = ({ size = "medium", className = "", label }) => {
  const s = sizeMap[size] || sizeMap.medium;
  return (
    <div className={`flex flex-col items-center justify-center gap-2 ${className}`}>
      <div
        className={`${s.box} ${s.border} rounded-full border-brand-100 border-t-brand-700 animate-spin`}
        role="status"
        aria-label={label || "Loading"}
      />
      {label && <span className="text-xs text-ink-muted font-medium">{label}</span>}
    </div>
  );
};

export default LoadingSpinner;
